// extracted by mini-css-extract-plugin
export default {"switchTab":"styles_switchTab__2wCbI","header":"styles_header__DmZ6-","tabAndLayout":"styles_tabAndLayout__sHTCp","expandWrapper":"styles_expandWrapper__JaYWE"};